import { ApiResponse } from 'apisauce';
import { ErrorInfo } from '../shared/interfaces/error-info.interface';
import { ResponseModel } from '../shared/interfaces/response-model.interface';
import {
  UnitHistoryRequestModel,
  UnitHistoryResponseModel
} from '../shared/models/unit-history.model';
import api from '../shared/services/utils/api/api.service';
import errorHelper from '../shared/services/utils/api/error-helper.service';

const MODULE_NAME = 'unit-life-cycle-list';

export function getUnitHistory(
  request: UnitHistoryRequestModel
): Promise<UnitHistoryResponseModel | ErrorInfo> {
  return api
    .getUnitHistory(request)
    .then((response: ApiResponse<ResponseModel<UnitHistoryResponseModel>, ErrorInfo>) => {
      if (response.ok) {
        const { data } = response;
        if (data && data.data) {
          return data.data;
        }

        return errorHelper(0, '', MODULE_NAME, (api.getUnitHistory as any).displayName);
      }

      return errorHelper(
        Number(response.status),
        response.data && response.data.errorCode
          ? String(response.data.errorCode || '')
          : response.problem,
        MODULE_NAME,
        (api.getUnitHistory as any).displayName
      );
    });
}
